export type GasEmptyMessage = 'default' | 'message' | 'success' | 'warning' | 'error' | 'filter' | 'search';

export interface GasEmptyMessageIcon {
  name: string;
  size: number;
  colorClass?: string;
}

export const ICON_NAMES = {
  default: {
    name: '',
    colorClass: '',
  },
  message: {
    name: 'common-message',
    colorClass: 'icon-brand',
  },
  success: {
    name: 'notifications-light-success',
    colorClass: 'icon-brand',
  },
  warning: {
    name: 'notifications-light-warning',
    colorClass: 'icon-warning',
  },
  error: {
    name: 'notifications-light-error',
    colorClass: 'icon-error',
  },
  filter: {
    name: 'common-filter-list',
    colorClass: 'icon-dark',
  },
  search: {
    name: 'common-search',
    colorClass: 'icon-dark',
  },
};
